import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../_core/_services/api.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalSubscriptionService {
  constructor(private api: ApiService) {}

  getPortalSubscriptions(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams
      };
    } else {
      queryParams = {
        limit: 100,
        offset: 0,
        q: '',
        filter: []
      };
    }

    return this.api.getAPI('portal/management/subscriptions', queryParams).pipe(
      map((res: any) => {
        console.log('res subs ', res);
        return res.body;
      })
    );
  }

  getPortalSubscriptionByCustomer(portalCustomerId: number) {
    return this.api
      .getAPI(`portal/subscriptions/customer/${portalCustomerId}`)
      .pipe(map((res: any) => res.body.data));
  }

  getPortalSubscriptionById(portalSubscriptionId: number) {
    return this.api
      .getAPI(`portal/subscriptions/${portalSubscriptionId}`)
      .pipe(map((res: any) => res.body.data));
  }

  downloadAccountStatement(dateFrom?: string, dateTo?: string): Observable<any> {
    const queryParams: Record<string, string> = {};
    if (dateFrom) {
      queryParams['date_from'] = dateFrom;
    }
    if (dateTo) {
      queryParams['date_to'] = dateTo;
    }
    return this.api.getFileAPI('portal/subscriptions/statement', '', queryParams);
  }

  regradeSubscription(subscriptionId: number, regradePortalProductId: number): Observable<any> {
    return this.api
      .postAPI(`portal/subscriptions/${subscriptionId}/regrade`, {
        regrade_portal_product_id: regradePortalProductId
      })
      .pipe(map((res: any) => res.body));
  }

  claimCircuit(subscriptionId: number, deviceReference: string): Observable<any> {
    return this.api
      .postAPI(`portal/subscriptions/${subscriptionId}/claim-circuit`, {
        device_reference: deviceReference
      })
      .pipe(map((res: any) => res.body));
  }

  updatePaymentMethod(subscriptionId: number, preferredPaymentMethod: string): Observable<any> {
    return this.api
      .postAPI(`portal/subscriptions/${subscriptionId}/payment-method`, {
        preferred_payment_method: preferredPaymentMethod
      })
      .pipe(map((res: any) => res.body));
  }
}
